import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router"
import { Router } from '@angular/router';
import { RouteDirectionsService } from '../../services/route-directions.service';
import { ScheduleTimetableComponent } from '../../components/schedule-timetable/schedule-timetable.component';


@Component({
  selector: 'app-route-direction-selector',
  templateUrl: './route-direction-selector.component.html',
  styleUrls: ['./route-direction-selector.component.css']
})
export class RouteDirectionSelectorComponent implements OnInit {

  public selected_route: string = "1";
  public selected_direction: string = "0";
  public directions: any = [{ Direction: 0, DirectionDescription: 'Inbound' }, { Direction: 1, DirectionDescription: 'Outbound' }];

  constructor(private route: ActivatedRoute, private routeDirectionsService: RouteDirectionsService, private router: Router, private scheduleTimetableComponent: ScheduleTimetableComponent) { 
    this.selected_route = this.route.snapshot.paramMap.get('route');
    this.selected_direction = this.route.snapshot.paramMap.get('direction');

    if (this.selected_direction == null) {
      this.selected_direction = "0";
    }

    this.routeDirectionsService.get(this.selected_route)
      .subscribe(routes => this.directions = routes);
  }

  ngOnInit(): void {
  }

  //On select of the direction
  onDirectionChange(direction: string): void {

    if(this.scheduleTimetableComponent.selected_date){
      this.router.navigateByUrl('schedule/timetable/' + this.selected_route + '/' + direction + '/' + this.scheduleTimetableComponent.selected_date);
      this.selected_direction = direction;
      this.scheduleTimetableComponent.load_timetable(direction);
    }
    else{
      this.router.navigateByUrl('schedule/timetable/' + this.selected_route + '/' + direction);
      this.selected_direction = direction;
      this.scheduleTimetableComponent.load_timetable(direction);
    }
  }

}
